<template>
  <section class="vd-empty-component">
    <div class="message-header">
      <svg width="180" height="43" viewBox="0 0 180 43" xmlns="http://www.w3.org/2000/svg" class="shrug-guy">
        <defs>
          <filter id="b" x="-1.1%" y="-4.7%" width="102.2%" height="109.5%" filterUnits="objectBoundingBox">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1" />
            <feOffset dy="1" in="shadowBlurInner1" result="shadowOffsetInner1" />
            <feComposite
              in="shadowOffsetInner1"
              in2="SourceAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
              result="shadowInnerInner1"
            />
            <feColorMatrix
              values="0 0 0 0 0.0235294118 0 0 0 0 0.482352941 0 0 0 0 0.941176471 0 0 0 0.2 0"
              in="shadowInnerInner1"
            />
          </filter>
          <path
            id="a"
            d="M75.96 5.69a2.58 2.58 0 00-2.18 3.7c1.2 2.58 1.88 5.32 2.57 8.25a2.58 2.58 0 005.04-1.08l-.02-.1c-.7-2.95-1.44-6.09-2.92-9.25a2.58 2.58 0 00-2.49-1.52zm27.64-.08a2.58 2.58 0 00-2.48 2.13C99.15 18.08 93.9 26.07 82.5 31.42a2.58 2.58 0 102.1 4.71l.1-.05c12.68-5.95 19.28-15.78 21.49-27.37a2.58 2.58 0 00-2.6-3.1zm-36.55-.34c-.85.04-1.63.5-2.07 1.23-2.88 4.56-4.55 10.6-4.55 17.24 0 6.64 1.67 12.69 4.55 17.25a2.58 2.58 0 104.4-2.7l-.04-.05c-2.25-3.56-3.75-8.74-3.75-14.5 0-5.75 1.5-10.93 3.75-14.49a2.58 2.58 0 00-2.3-3.98zm45.83 0a2.58 2.58 0 00-2.22 3.98c2.25 3.56 3.75 8.74 3.75 14.5 0 5.75-1.5 10.93-3.75 14.49a2.58 2.58 0 004.32 2.81l.04-.06c2.88-4.56 4.55-10.61 4.55-17.25 0-6.63-1.67-12.68-4.55-17.24a2.59 2.59 0 00-2.14-1.24zM87.98 3.4a2.58 2.58 0 00-2.36 3.4c.88 2.72 1.22 5.52 1.54 8.51a2.58 2.58 0 105.13-.5v-.04c-.33-3.03-.69-6.23-1.77-9.56A2.58 2.58 0 0088 3.4zM164.01 0c-1.81 0-3.36.06-4.84.32a8.8 8.8 0 00-5.24 2.9c-2.7 3.21-3.65 7.97-6.04 17.3-2.38 9.34-3.81 13.87-5 15.28-.58.7-.97.91-2.18 1.13-1.21.21-3.15.24-5.84.24l-11.46-.1a2.58 2.58 0 10-.04 5.16l11.47.1h.01c2.7 0 4.8.02 6.76-.33a8.78 8.78 0 005.24-2.9c2.7-3.2 3.65-7.97 6.04-17.3 2.39-9.33 3.81-13.87 5-15.27.58-.7.98-.92 2.19-1.14 1.2-.21 3.14-.23 5.83-.23l11.46.09a2.58 2.58 0 00.1-5.16h-.06L165.94 0h-1.93zM14.06 0L2.6.09a2.58 2.58 0 10-.02 5.16h.06l11.44-.1c2.7 0 4.64.03 5.86.25 1.2.21 1.6.42 2.2 1.13 1.17 1.4 2.6 5.94 4.98 15.27 2.4 9.33 3.34 14.1 6.04 17.3A8.79 8.79 0 0038.4 42c1.97.35 4.07.32 6.76.32h.01l11.47-.09a2.58 2.58 0 10-.04-5.15l-11.44.09c-2.7 0-4.64-.03-5.85-.24-1.21-.22-1.6-.43-2.2-1.13-1.18-1.41-2.6-5.94-4.99-15.28-2.39-9.33-3.34-14.09-6.04-17.3a8.8 8.8 0 00-5.24-2.9C18.87-.03 16.77 0 14.07 0z"
          />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g fill-rule="nonzero">
            <use fill="#E6F1FD" xlink:href="#a" />
            <use fill="#000" filter="url(#b)" xlink:href="#a" />
          </g>
        </g>
      </svg>
      <h1 class="no-data" data-cy="vd-empty-title">
        {{ title }}
      </h1>
    </div>
    <div class="message-body" data-cy="vd-empty-message-body">
      <!-- @slot the body of the placeholder (your complete message) -->
      <slot />
    </div>
    <div class="actions-buttons" data-cy="vd-empty-action-buttons">
      <!-- @slot The buttons or links you want the user to click on -->
      <slot name="actions" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/**
 * This component is a helper to show empty or not found data.
 * You may customize it with the help of the `title` prop
 * and the two slots `body` (for the message) and `actions`
 * (for the links or buttons you want the user to click on)
 */
export default defineComponent({
  name: "VDEmpty",
  props: {
    /**
     * the title under the shrug emoji
     */
    title: {
      type: String,
      required: false,
      default: "no data",
    },
  },
});
</script>

<style lang="scss" scoped>
.vd-empty-component {
  display: grid;
  align-content: center;
  justify-content: center;
  text-align: center;

  grid-template-columns: 400px;

  margin: #{size("XXL") * 2} 0;

  .shrug-guy {
    display: inline-block;
    margin: 0 auto;
  }

  .message-header {
    display: inline-block;

    .no-data {
      line-height: 46px;
      font-size: font("XL");
      font-weight: 800;
      font-family: "Open Sans", "Helvetica Neue", sans-serif;
      color: transparent;
      word-break: break-word;

      margin: 0;

      background-color: rgba(6, 123, 240, 0.2);
      -webkit-background-clip: text;
      -moz-background-clip: text;
      background-clip: text;
    }
  }

  .message-body {
    font-size: font("S");
  }

  .actions-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: size("M");

    > div {
      margin: size("M");
    }
  }
}
</style>
